import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EngineerRecommendationsDetailsComponent } from './engineer-recommendations-details.component';

const routes: Routes = [
  { path: '', component: EngineerRecommendationsDetailsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EngineerRecommendationsDetailsRoutingModule {}
